/**
 * Milagron - Beden Tablosu (Size Chart)
 *
 * Ürün sayfasında çalışır:
 *   1. /apps/efx-mila proxy'sinden getSizeChart ile içeriği alır (panel/giriş aynı kalır)
 *   2. "Beden" seçeneğinin başlık satırının sağına çerçeveli "Beden tablosu" düğmesi koyar
 *      (Beden seçeneği yoksa varyant seçicinin altına). Eski ayrı "Beden Tablosu" sekmesi yok.
 *   3. Düğme tek bir pencere açar: masaüstünde ortada, mobilde alttan. İçerik türüne göre:
 *      - Görsel: pencere genişliğinde, dokununca yakınlaştırmalı tam ekran (pinch/zoom)
 *      - Tablo: okunur boyut, ilk sütun sabit, yana kaydırma, seçili beden vurgulu
 *      - Yazı: düzgün paragraflar, kalın başlıklar
 *      - "Nasıl ölçülür?" bölümü varsa kapalı açılır bölüme alınır (en altta)
 *      - cm ve inç iki ayrı tablo ise üstte cm / inç geçişi
 */
(function () {
    'use strict';

    var DEBUG = false;
    function dbg() { if (DEBUG && window.console) console.log.apply(console, ['[size-chart]'].concat([].slice.call(arguments))); }
    function dbgWarn() { if (window.console) console.warn.apply(console, ['[size-chart]'].concat([].slice.call(arguments))); }

    if (!/\/products\/[^\/?#]+/.test(window.location.pathname)) {
        dbg('not a product page, skipping');
        return;
    }

    if (window.__efxSizeChartLoaded) return;
    window.__efxSizeChartLoaded = true;

    // ============================================================
    // Proxy
    // ============================================================
    async function sendToProxy(payload) {
        dbg('proxy →', payload.action, payload);
        try {
            var r = await fetch('/apps/efx-mila', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!r.ok) throw new Error('HTTP ' + r.status);
            var json = await r.json();
            dbg('proxy ←', payload.action, json);
            return json;
        } catch (e) {
            dbgWarn('proxy hata', payload.action, e.message);
            return null;
        }
    }

    // ============================================================
    // Product ID tespiti
    // ============================================================
    function getProductIdSync() {
        try {
            if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) {
                return String(window.ShopifyAnalytics.meta.product.id);
            }
        } catch (e) {}
        var el = document.querySelector('[data-product-id]');
        if (el && el.dataset.productId) return String(el.dataset.productId);
        return null;
    }

    async function getProductIdAsync() {
        var sync = getProductIdSync();
        if (sync) return sync;
        var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        if (!m) return null;
        try {
            var r = await fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } });
            if (!r.ok) return null;
            var p = await r.json();
            return p && p.id ? String(p.id) : null;
        } catch (e) {
            dbgWarn('product.js fetch hata', e.message);
            return null;
        }
    }

    // ============================================================
    // Yardımcılar
    // ============================================================
    function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }
    function txt(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }
    function lower(s) { try { return String(s || '').toLocaleLowerCase('tr'); } catch (e) { return String(s || '').toLowerCase(); } }
    function norm(s) { return lower(s).replace(/[\s()\[\]]+/g, ''); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    var IS_TOUCH = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    var SC = { html: null, link: null, modal: null };

    var ICON_RULER = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.6 16.2 16.2 3.6l4.2 4.2L7.8 20.4z"/><path d="m7.4 12.4 1.8 1.8M9.9 9.9l1.2 1.2M12.4 7.4l1.8 1.8"/></svg>';
    var ICON_X = '<svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg>';
    var ICON_ZOOM = '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="8.6" cy="8.6" r="5.6"/><path d="m13 13 4.5 4.5M8.6 6.4v4.4M6.4 8.6h4.4"/></svg>';
    var ICON_CHEV = '<svg viewBox="0 0 12 8" width="12" height="8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.5 1.8 6 6.2l4.5-4.4"/></svg>';

    // ============================================================
    // Beden seçeneği
    // ============================================================
    var SIZE_RE = /^(beden|size|numara|ölçü|olcu|boy)/i;

    function findSizeSelector() {
        var opts = document.querySelectorAll('variant-picker .option-selector');
        for (var i = 0; i < opts.length; i++) {
            var o = opts[i];
            if (o.classList.contains('efx-hidden-option')) continue;
            var lg = o.querySelector('legend, .label');
            var t = txt(lg) || o.getAttribute('data-order') || '';
            if (SIZE_RE.test(t.trim())) return o;
        }
        return null;
    }

    function selectedSize() {
        var o = findSizeSelector();
        if (!o) return '';
        var c = o.querySelector('input.js-option:checked, input[type="radio"]:checked');
        if (c) return c.value || '';
        var s = o.querySelector('select');
        if (s && s.value) return s.value;
        return '';
    }

    // ============================================================
    // "Beden tablosu" düğmesi
    // ============================================================
    function makeLink() {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'efx-sc-link';
        b.setAttribute('aria-haspopup', 'dialog');
        b.innerHTML = ICON_RULER + '<span>Beden tablosu</span>';
        b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openModal();
        });
        return b;
    }

    function findAciklamaAccordion() {
        var nodes = document.querySelectorAll('.product-info-accordion');
        for (var i = 0; i < nodes.length; i++) {
            var summary = nodes[i].querySelector('.disclosure__title, summary');
            if (summary) {
                var t = lower(txt(summary));
                if (t === 'açıklama' || t === 'aciklama' || t === 'description') return nodes[i];
            }
        }
        return document.querySelector('.product-info-accordion');
    }

    function placeLink() {
        if (!SC.html) return;
        if (SC.link && document.documentElement.contains(SC.link)) return;

        var link = makeLink();
        var opt = findSizeSelector();
        var lg = opt && opt.querySelector('legend, .label');

        if (opt && lg) {
            var row = document.createElement('div');
            row.className = 'efx-sc-head';
            lg.parentNode.insertBefore(row, lg);
            row.appendChild(lg);
            row.appendChild(link);
        } else {
            var wrap = document.createElement('div');
            wrap.className = 'efx-sc-solo';
            wrap.appendChild(link);
            var vp = document.querySelector('variant-picker');
            if (vp) {
                vp.insertAdjacentElement('afterend', wrap);
            } else {
                var a = findAciklamaAccordion();
                if (!a) { dbgWarn('düğme için yer bulunamadı'); return; }
                a.insertAdjacentElement('beforebegin', wrap);
            }
        }
        SC.link = link;
        dbg('düğme yerleştirildi');
    }

    // ============================================================
    // İçeriği düzenleme
    // ============================================================
    var HOW_RE = /(nas[ıi]l [öo]l[çc]|[öo]l[çc][üu]\s*(nas[ıi]l|al[ıi]n|alma)|[öo]l[çc][üu]m rehberi|[öo]l[çc][üu] rehberi|how to measure|measuring guide)/i;

    function isHeading(el) {
        if (!el || el.nodeType !== 1) return false;
        if (/^H[1-6]$/.test(el.tagName)) return true;
        var t = txt(el);
        if (!t || t.length > 70) return false;
        if (/^(STRONG|B)$/.test(el.tagName)) return true;
        if (/^(P|DIV)$/.test(el.tagName)) {
            if (el.querySelector('table, img')) return false;
            var b = el.querySelector('strong, b');
            return !!b && txt(b) === t;
        }
        return false;
    }

    function ownText(el) {
        var s = '';
        each(el.childNodes, function (n) { if (n.nodeType === 3) s += n.nodeValue; });
        return s.trim();
    }

    function topChild(el, root) {
        while (el && el.parentNode !== root) el = el.parentNode;
        return el;
    }

    function processContent(c, m) {
        // temizlik
        each(c.querySelectorAll('script, style, link, meta'), function (n) { n.remove(); });
        each(c.querySelectorAll('p'), function (p) {
            if (!txt(p).replace(/ /g, '') && !p.querySelector('img, table, iframe, video')) p.remove();
        });

        // tek sarmalayıcıların içine in
        var lvl = c;
        while (lvl.children.length === 1 && !ownText(lvl) && /^(DIV|SECTION|ARTICLE)$/.test(lvl.firstElementChild.tagName)) {
            lvl = lvl.firstElementChild;
        }

        // tablolar
        each(c.querySelectorAll('table'), function (t) {
            ['width', 'style', 'border', 'cellpadding', 'cellspacing', 'align', 'bgcolor'].forEach(function (a) { t.removeAttribute(a); });
            each(t.querySelectorAll('td, th'), function (cell) {
                cell.removeAttribute('width');
                cell.removeAttribute('bgcolor');
                cell.style.width = '';
                cell.style.minWidth = '';
                cell.style.background = '';
                cell.style.backgroundColor = '';
                if (txt(cell).length <= 18) cell.classList.add('efx-nw');
            });
            t.classList.add('efx-scm__tbl');
            var headRows = t.tHead ? t.tHead.rows : null;
            if (headRows && headRows.length) each(headRows, function (r) { r.classList.add('efx-scm__hr'); });
            else if (t.rows[0]) t.rows[0].classList.add('efx-scm__hr');
            var w = document.createElement('div');
            w.className = 'efx-scm__tw';
            t.parentNode.insertBefore(w, t);
            w.appendChild(t);
        });

        // görseller
        each(c.querySelectorAll('img'), function (img) {
            img.removeAttribute('width');
            img.removeAttribute('height');
            img.removeAttribute('loading');
            img.style.width = '';
            img.style.height = '';
            var a = img.closest('a');
            if (a) a.removeAttribute('href');
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'efx-scm__img';
            b.setAttribute('aria-label', 'Görseli büyüt');
            img.parentNode.insertBefore(b, img);
            b.appendChild(img);
            var h = document.createElement('span');
            h.className = 'efx-scm__zh';
            h.innerHTML = ICON_ZOOM + (IS_TOUCH ? 'Büyütmek için dokun' : 'Büyütmek için tıkla');
            b.appendChild(h);
            function check() { if (img.naturalWidth && img.naturalWidth < 240) b.classList.add('is-small'); }
            if (img.complete) check(); else img.addEventListener('load', check, { once: true });
            b.addEventListener('click', function (e) {
                e.preventDefault();
                if (b.classList.contains('is-small')) return;
                openLightbox(img.currentSrc || img.src, img.alt || 'Beden Tablosu');
            });
        });

        // cm / inç geçişi
        var tws = [].slice.call(c.querySelectorAll('.efx-scm__tw'));
        if (tws.length >= 2) {
            var cm = null, inch = null;
            tws.forEach(function (tw) {
                var block = topChild(tw, lvl) || tw;
                var prev = block.previousElementSibling;
                var head = prev && isHeading(prev) ? prev : null;
                var t = tw.querySelector('table');
                var s = lower((head ? txt(head) : '') + ' ' + (t.caption ? txt(t.caption) : '') + ' ' + (t.rows[0] ? txt(t.rows[0]) : ''));
                var isIn = /(inç|inch|\binc\b|\(in\)|["″])/.test(s);
                var isCm = /(\bcm\b|santim)/.test(s);
                var info = { block: block, head: head };
                if (isCm && !isIn && !cm) cm = info;
                else if (isIn && !isCm && !inch) inch = info;
            });
            if (cm && inch && cm.block !== inch.block) {
                var u = m.querySelector('.efx-scm__units');
                u.innerHTML = '<div class="efx-scm__seg" role="tablist" aria-label="Ölçü birimi">' +
                    '<button type="button" role="tab" data-u="cm">cm</button>' +
                    '<button type="button" role="tab" data-u="in">inç</button></div>';
                u.hidden = false;
                var setU = function (k) {
                    cm.block.hidden = k !== 'cm';
                    if (cm.head) cm.head.hidden = k !== 'cm';
                    inch.block.hidden = k !== 'in';
                    if (inch.head) inch.head.hidden = k !== 'in';
                    each(u.querySelectorAll('button'), function (bt) {
                        var on = bt.getAttribute('data-u') === k;
                        bt.classList.toggle('is-on', on);
                        bt.setAttribute('aria-selected', on ? 'true' : 'false');
                    });
                };
                u.addEventListener('click', function (e) {
                    var bt = e.target.closest('[data-u]');
                    if (bt) setU(bt.getAttribute('data-u'));
                });
                setU('cm');
            }
        }

        // "Nasıl ölçülür?" → kapalı açılır bölüm, en alta
        var kids = [].slice.call(lvl.children);
        var start = -1;
        for (var i = 0; i < kids.length; i++) {
            if (isHeading(kids[i]) && HOW_RE.test(txt(kids[i]))) { start = i; break; }
        }
        if (start >= 0) {
            var grp = [];
            for (var j = start + 1; j < kids.length; j++) {
                var k = kids[j];
                if (isHeading(k) || k.classList.contains('efx-scm__tw') || k.querySelector('.efx-scm__tw')) break;
                grp.push(k);
            }
            if (grp.length) {
                var d = document.createElement('details');
                d.className = 'efx-scm__how';
                d.innerHTML = '<summary><span>Nasıl ölçülür?</span>' + ICON_CHEV + '</summary><div class="efx-scm__how-b"></div>';
                var hb = d.querySelector('.efx-scm__how-b');
                grp.forEach(function (n) { hb.appendChild(n); });
                kids[start].remove();
                lvl.appendChild(d);
            }
        }
    }

    // Seçili bedeni tabloda vurgula
    function sizeMatches(cellText, key) {
        if (!key) return false;
        if (norm(cellText) === key) return true;
        var parts = lower(cellText).split(/[\s\/()|,\-–]+/).filter(Boolean);
        return parts.indexOf(key) !== -1;
    }

    function highlight(m) {
        var c = m.querySelector('.efx-scm__c');
        each(c.querySelectorAll('.efx-hl'), function (n) { n.classList.remove('efx-hl'); });
        each(c.querySelectorAll('.efx-hl-row'), function (n) { n.classList.remove('efx-hl-row'); });
        var note = m.querySelector('.efx-scm__sel');
        note.hidden = true;

        var size = selectedSize();
        var key = norm(size);
        if (!key) return;
        var hit = false;

        each(c.querySelectorAll('table'), function (t) {
            var rows = t.rows;
            if (!rows.length) return;
            // 1) başlık satırında sütun ara
            for (var r = 0; r < Math.min(2, rows.length); r++) {
                var col = -1, span = 1, pos = 0;
                for (var ci = 0; ci < rows[r].cells.length; ci++) {
                    var cell = rows[r].cells[ci];
                    if (ci > 0 && sizeMatches(txt(cell), key)) { col = pos; span = cell.colSpan || 1; break; }
                    pos += cell.colSpan || 1;
                }
                if (col >= 0) {
                    each(rows, function (row) {
                        var p = 0;
                        each(row.cells, function (cl) {
                            var cs = cl.colSpan || 1;
                            if (p < col + span && p + cs > col && !(p === 0 && col > 0 && cs === 1 && row.cells[0] === cl)) cl.classList.add('efx-hl');
                            p += cs;
                        });
                    });
                    hit = true;
                    return;
                }
            }
            // 2) ilk sütunda satır ara
            each(rows, function (row) {
                if (row.classList.contains('efx-scm__hr')) return;
                if (row.cells[0] && sizeMatches(txt(row.cells[0]), key)) { row.classList.add('efx-hl-row'); hit = true; }
            });
        });

        if (hit) {
            note.innerHTML = '<span>Seçtiğin beden <b>' + esc(size) + '</b> tabloda işaretli</span>';
            note.hidden = false;
        }
    }

    // ============================================================
    // Pencere
    // ============================================================
    var lastFocus = null;

    function buildModal() {
        if (SC.modal) return SC.modal;
        var m = document.createElement('div');
        m.className = 'efx-scm';
        m.hidden = true;
        m.innerHTML =
            '<div class="efx-scm__ov" data-scm-close></div>' +
            '<div class="efx-scm__dlg" role="dialog" aria-modal="true" aria-labelledby="efx-scm-t">' +
            '  <div class="efx-scm__hd">' +
            '    <span class="efx-scm__grab" aria-hidden="true"></span>' +
            '    <span class="efx-scm__hic" aria-hidden="true">' + ICON_RULER + '</span>' +
            '    <h2 class="efx-scm__t" id="efx-scm-t">Beden Tablosu</h2>' +
            '    <button type="button" class="efx-scm__x" data-scm-close aria-label="Kapat">' + ICON_X + '</button>' +
            '  </div>' +
            '  <div class="efx-scm__bd">' +
            '    <div class="efx-scm__units" hidden></div>' +
            '    <div class="efx-scm__sel" hidden></div>' +
            '    <div class="efx-scm__c"></div>' +
            '  </div>' +
            '</div>';
        document.body.appendChild(m);
        m.addEventListener('click', function (e) {
            if (e.target.closest('[data-scm-close]')) { e.preventDefault(); closeModal(); }
        });
        var c = m.querySelector('.efx-scm__c');
        c.innerHTML = SC.html;
        try { processContent(c, m); } catch (err) { dbgWarn('içerik düzenleme hata', err); }
        SC.modal = m;
        return m;
    }

    function onKey(e) {
        if (e.key !== 'Escape') return;
        if (document.querySelector('.efx-sc-lb')) return; // önce büyük görünüm kapanır
        closeModal();
    }

    function openModal() {
        var m = buildModal();
        highlight(m);
        lastFocus = document.activeElement;
        m.hidden = false;
        document.documentElement.classList.add('efx-scm-lock');
        void m.offsetWidth;
        m.classList.add('is-open');
        m.querySelector('.efx-scm__bd').scrollTop = 0;
        document.addEventListener('keydown', onKey);
        setTimeout(function () {
            var x = m.querySelector('.efx-scm__x');
            if (x && !IS_TOUCH) try { x.focus({ preventScroll: true }); } catch (e) {}
        }, 60);
    }

    function closeModal() {
        var m = SC.modal;
        if (!m || !m.classList.contains('is-open')) return;
        m.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        document.documentElement.classList.remove('efx-scm-lock');
        setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 240);
        if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }

    // ============================================================
    // Stil
    // ============================================================
    function injectStyles() {
        if (document.getElementById('efx-sc-style')) return;
        var style = document.createElement('style');
        style.id = 'efx-sc-style';
        style.textContent = [
            /* Düğme: Beden başlığının sağında */
            '.efx-sc-head{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;margin:0 0 10px;}',
            'html body .option-selector .efx-sc-head>legend,html body .option-selector .efx-sc-head>.label{margin:0!important;padding:0!important;float:none;width:auto;}',
            '.efx-sc-link{display:inline-flex;align-items:center;gap:7px;height:34px;margin:0;padding:0 13px;border:1px solid #d6d3cd;border-radius:9px;background:#fff;color:#141414;font-family:inherit;font-size:13px;font-weight:600;line-height:1;letter-spacing:0;text-transform:none;cursor:pointer;white-space:nowrap;-webkit-appearance:none;appearance:none;transition:border-color .15s,background .15s;-webkit-tap-highlight-color:transparent;}',
            '.efx-sc-link:hover{border-color:#141414;}',
            '.efx-sc-link:active{background:#f3f3f2;}',
            '.efx-sc-link svg{flex:none;width:16px;height:16px;}',
            '.efx-sc-solo{margin:12px 0 4px;}',

            /* Pencere */
            '.efx-scm{position:fixed;inset:0;z-index:100050;display:flex;align-items:center;justify-content:center;font-family:inherit;}',
            '.efx-scm[hidden],.efx-scm [hidden]{display:none!important;}',
            '.efx-scm__ov{position:absolute;inset:0;background:rgba(20,20,20,.45);opacity:0;transition:opacity .2s ease;}',
            '.efx-scm.is-open .efx-scm__ov{opacity:1;}',
            '.efx-scm__dlg{position:relative;display:flex;flex-direction:column;width:min(760px,calc(100vw - 48px));max-height:min(84vh,880px);background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.22);opacity:0;transform:translateY(12px) scale(.985);transition:opacity .2s ease,transform .24s cubic-bezier(.2,.8,.2,1);}',
            '.efx-scm.is-open .efx-scm__dlg{opacity:1;transform:none;}',
            '.efx-scm__hd{position:relative;flex:none;display:flex;align-items:center;gap:10px;padding:14px 16px 14px 20px;border-bottom:1px solid #ececec;background:#fff;}',
            '.efx-scm__hic{flex:none;display:flex;color:#141414;}',
            '.efx-scm__hic svg{width:18px;height:18px;}',
            '.efx-scm__t{flex:1;min-width:0;margin:0;font-family:inherit;font-size:16px;font-weight:700;line-height:1.3;letter-spacing:0;text-transform:none;color:#141414;}',
            '.efx-scm__x{flex:none;width:36px;height:36px;display:flex;align-items:center;justify-content:center;margin:0;padding:0;border:1px solid #e3e1dc;border-radius:10px;background:#fff;color:#141414;cursor:pointer;}',
            '.efx-scm__x:hover{border-color:#141414;}',
            '.efx-scm__grab{display:none;}',
            '.efx-scm__bd{flex:1;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:18px 20px 24px;}',
            'html.efx-scm-lock,html.efx-scm-lock body{overflow:hidden!important;}',

            /* Birim geçişi + seçili beden notu */
            '.efx-scm__units{margin:0 0 14px;}',
            '.efx-scm__seg{display:inline-flex;padding:3px;border-radius:10px;background:#f2f1ee;}',
            '.efx-scm__seg button{min-width:68px;height:32px;margin:0;padding:0 14px;border:0;border-radius:8px;background:transparent;color:#6f6a64;font-family:inherit;font-size:13px;font-weight:600;cursor:pointer;}',
            '.efx-scm__seg button.is-on{background:#fff;color:#141414;box-shadow:0 1px 3px rgba(0,0,0,.12);}',
            '.efx-scm__sel{display:flex;align-items:center;gap:8px;margin:0 0 12px;padding:9px 12px;border-radius:10px;background:#f6f1ea;color:#3a2f22;font-size:13px;line-height:1.35;}',
            '.efx-scm__sel::before{content:"";flex:none;width:8px;height:8px;border-radius:50%;background:#141414;}',
            '.efx-scm__sel b{font-weight:700;color:#141414;}',

            /* Yazı */
            '.efx-scm__c{font-size:14px;line-height:1.6;color:#3b3b3b;}',
            '.efx-scm__c>:first-child,.efx-scm__c>div>:first-child{margin-top:0!important;}',
            '.efx-scm__c p{margin:0 0 10px;}',
            '.efx-scm__c h1,.efx-scm__c h2,.efx-scm__c h3,.efx-scm__c h4,.efx-scm__c h5,.efx-scm__c h6{margin:18px 0 8px;font-family:inherit;font-size:15px;font-weight:700;line-height:1.35;letter-spacing:0;text-transform:none;color:#141414;}',
            '.efx-scm__c strong,.efx-scm__c b{font-weight:700;color:#141414;}',
            '.efx-scm__c ul,.efx-scm__c ol{margin:0 0 12px;padding-left:20px;}',
            '.efx-scm__c li{margin:0 0 4px;}',
            '.efx-scm__c iframe,.efx-scm__c video{max-width:100%;}',

            /* Tablo */
            '.efx-scm__tw{margin:4px 0 16px;overflow-x:auto;-webkit-overflow-scrolling:touch;border:1px solid #e6e4e0;border-radius:12px;background:#fff;}',
            '.efx-scm__tbl{width:100%!important;min-width:100%;margin:0!important;border:0!important;border-collapse:separate!important;border-spacing:0!important;table-layout:auto!important;background:#fff;color:#141414;font-size:13px!important;line-height:1.35;}',
            '.efx-scm__tbl td,.efx-scm__tbl th{padding:10px 12px!important;border:0!important;border-bottom:1px solid #efeee9!important;background:#fff;color:#141414!important;font-size:13px!important;font-weight:500;text-align:center;vertical-align:middle;}',
            '.efx-scm__tbl tr:last-child>*{border-bottom:0!important;}',
            '.efx-scm__tbl .efx-nw{white-space:nowrap;}',
            '.efx-scm__tbl tr.efx-scm__hr>*{background:#f6f6f4;font-weight:700;font-size:12.5px!important;}',
            '.efx-scm__tbl tr>*:first-child{position:sticky;left:0;z-index:1;text-align:left;font-weight:700;box-shadow:inset -1px 0 0 #e6e4e0;}',
            '.efx-scm__tbl .efx-hl,.efx-scm__tbl tr.efx-hl-row>*{background:#f6efe5!important;font-weight:700;}',
            '.efx-scm__tbl tr.efx-scm__hr>.efx-hl{background:#141414!important;color:#fff!important;}',

            /* Görsel */
            '.efx-scm__img{position:relative;display:block;width:100%;margin:4px 0 14px;padding:0;border:1px solid #ececec;border-radius:12px;background:#fff;overflow:hidden;cursor:zoom-in;font-family:inherit;-webkit-tap-highlight-color:transparent;}',
            '.efx-scm__img img{display:block;max-width:100%!important;height:auto!important;margin:0 auto;}',
            '.efx-scm__zh{position:absolute;right:10px;bottom:10px;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 11px;border-radius:999px;background:rgba(20,20,20,.78);color:#fff;font-size:11.5px;font-weight:600;line-height:1;pointer-events:none;}',
            '.efx-scm__img.is-small{display:inline-block;width:auto;border:0;cursor:default;}',
            '.efx-scm__img.is-small .efx-scm__zh{display:none;}',

            /* Nasıl ölçülür */
            '.efx-scm__how{margin:8px 0 0;border:1px solid #e6e4e0;border-radius:12px;background:#faf9f7;}',
            '.efx-scm__how>summary{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:14px;list-style:none;cursor:pointer;font-size:14px;font-weight:700;color:#141414;}',
            '.efx-scm__how>summary::-webkit-details-marker{display:none;}',
            '.efx-scm__how>summary svg{flex:none;transition:transform .2s;}',
            '.efx-scm__how[open]>summary svg{transform:rotate(180deg);}',
            '.efx-scm__how-b{padding:0 14px 14px;}',

            /* Mobil: alttan açılan pencere */
            '@media(max-width:767px){' +
                '.efx-scm{align-items:flex-end;}' +
                '.efx-scm__dlg{width:100%;max-height:86vh;max-height:86dvh;border-radius:18px 18px 0 0;transform:translateY(100%);padding-bottom:env(safe-area-inset-bottom);}' +
                '.efx-scm.is-open .efx-scm__dlg{transform:none;}' +
                '.efx-scm__grab{display:block;position:absolute;top:6px;left:50%;width:36px;height:4px;margin-left:-18px;border-radius:2px;background:#d9d6d0;}' +
                '.efx-scm__hd{padding:18px 14px 12px 16px;}' +
                '.efx-scm__bd{padding:14px 16px 20px;}' +
                '.efx-scm__tbl td,.efx-scm__tbl th{padding:9px 10px!important;}' +
            '}',

            /* Lightbox */
            '.efx-sc-lb{position:fixed;inset:0;background:rgba(0,0,0,.92);z-index:100100;display:flex;align-items:center;justify-content:center;animation:efxScLbFade .2s ease;overflow:hidden;touch-action:none;user-select:none;-webkit-user-select:none;}',
            '.efx-sc-lb__stage{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;overflow:hidden;}',
            '.efx-sc-lb__img{max-width:95vw;max-height:92vh;width:auto;height:auto;object-fit:contain;display:block;box-shadow:0 25px 60px rgba(0,0,0,.5);background:#fff;animation:efxScLbZoom .2s ease;transform-origin:center center;will-change:transform;cursor:zoom-in;-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none;}',
            '.efx-sc-lb.is-zoomed .efx-sc-lb__img{cursor:grab;}',
            '.efx-sc-lb.is-grabbing .efx-sc-lb__img{cursor:grabbing;}',
            '.efx-sc-lb__close{position:absolute;top:16px;right:20px;width:44px;height:44px;border-radius:50%;border:none;background:rgba(255,255,255,.12);color:#fff;font-size:28px;line-height:1;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;transition:background .15s;z-index:2;}',
            '.efx-sc-lb__close:hover{background:rgba(255,255,255,.22);}',
            '.efx-sc-lb__zoom{position:absolute;top:16px;left:20px;display:flex;gap:8px;z-index:2;}',
            '.efx-sc-lb__zoom button{width:40px;height:40px;border-radius:50%;border:none;background:rgba(255,255,255,.12);color:#fff;font-size:20px;line-height:1;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;transition:background .15s;}',
            '.efx-sc-lb__zoom button:hover{background:rgba(255,255,255,.22);}',
            '.efx-sc-lb__zoom button:disabled{opacity:.4;cursor:not-allowed;}',
            '.efx-sc-lb__hint{position:absolute;bottom:18px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.6);font-size:12px;letter-spacing:.3px;pointer-events:none;text-align:center;line-height:1.5;padding:0 16px;}',
            '@keyframes efxScLbFade{from{opacity:0;}to{opacity:1;}}',
            '@keyframes efxScLbZoom{from{opacity:0;transform:scale(.92);}to{opacity:1;transform:scale(1);}}',
            '@media(max-width:600px){.efx-sc-lb__close{top:10px;right:10px;width:38px;height:38px;font-size:24px;}.efx-sc-lb__zoom{top:10px;left:10px;}.efx-sc-lb__zoom button{width:36px;height:36px;font-size:18px;}.efx-sc-lb__hint{font-size:11px;bottom:12px;}}'
        ].join('\n');
        document.head.appendChild(style);
    }

    // ============================================================
    // Lightbox + pan-zoom + pinch
    // ============================================================
    function openLightbox(src, alt) {
        var lb = document.createElement('div');
        lb.className = 'efx-sc-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Beden Tablosu (Büyük Görünüm)');
        lb.innerHTML =
            '<div class="efx-sc-lb__zoom">' +
            '  <button type="button" data-zoom="out" aria-label="Uzaklaştır">−</button>' +
            '  <button type="button" data-zoom="reset" aria-label="Sıfırla">⊙</button>' +
            '  <button type="button" data-zoom="in" aria-label="Yakınlaştır">+</button>' +
            '</div>' +
            '<button type="button" class="efx-sc-lb__close" aria-label="Kapat">&times;</button>' +
            '<div class="efx-sc-lb__stage"><img class="efx-sc-lb__img" alt=""></div>' +
            '<div class="efx-sc-lb__hint"></div>';

        var stage = lb.querySelector('.efx-sc-lb__stage');
        var img = lb.querySelector('.efx-sc-lb__img');
        var hint = lb.querySelector('.efx-sc-lb__hint');
        var btnIn = lb.querySelector('[data-zoom="in"]');
        var btnOut = lb.querySelector('[data-zoom="out"]');
        var btnReset = lb.querySelector('[data-zoom="reset"]');

        hint.textContent = IS_TOUCH
            ? 'Çift dokun veya parmaklarla yakınlaştır • Sürükleyerek gez'
            : 'Tıkla veya scroll ile yakınlaştır • Sürükleyerek gez • ESC kapat';

        img.src = src;
        if (alt) img.alt = alt;

        var scale = 1;
        var minScale = 1;
        var maxScale = 6;
        var panX = 0, panY = 0;
        var baseW = 0, baseH = 0;
        var stageW = 0, stageH = 0;

        function applyTransform() {
            img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
            lb.classList.toggle('is-zoomed', scale > 1.001);
            updateButtons();
        }

        function updateButtons() {
            btnOut.disabled = scale <= minScale + 0.001;
            btnIn.disabled = scale >= maxScale - 0.001;
        }

        function clampPan() {
            var sw = baseW * scale;
            var sh = baseH * scale;
            if (sw <= stageW) {
                panX = 0;
            } else {
                var maxPanX = (sw - stageW) / 2;
                panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
            }
            if (sh <= stageH) {
                panY = 0;
            } else {
                var maxPanY = (sh - stageH) / 2;
                panY = Math.max(-maxPanY, Math.min(maxPanY, panY));
            }
        }

        function measure() {
            var prevTransform = img.style.transform;
            img.style.transform = 'none';
            void img.offsetWidth;
            var stageRect = stage.getBoundingClientRect();
            stageW = stageRect.width;
            stageH = stageRect.height;
            baseW = img.clientWidth;
            baseH = img.clientHeight;
            img.style.transform = prevTransform;
        }

        function reset() {
            scale = 1;
            panX = 0;
            panY = 0;
            measure();
            applyTransform();
        }

        function zoomAt(clientX, clientY, newScale) {
            newScale = Math.max(minScale, Math.min(maxScale, newScale));
            if (newScale === scale) return;
            var stageRect = stage.getBoundingClientRect();
            var sx = clientX - stageRect.left;
            var sy = clientY - stageRect.top;
            var cx = stageW / 2;
            var cy = stageH / 2;
            var dx = sx - (cx + panX);
            var dy = sy - (cy + panY);
            var ix = dx / scale;
            var iy = dy / scale;
            scale = newScale;
            panX = sx - cx - ix * scale;
            panY = sy - cy - iy * scale;
            clampPan();
            applyTransform();
        }

        function zoomCenter(newScale) {
            var stageRect = stage.getBoundingClientRect();
            zoomAt(stageRect.left + stageW / 2, stageRect.top + stageH / 2, newScale);
        }

        function onWheel(e) {
            e.preventDefault();
            var delta = -e.deltaY;
            var factor = delta > 0 ? 1.15 : 1 / 1.15;
            zoomAt(e.clientX, e.clientY, scale * factor);
        }

        var pointers = {};
        var dragStart = null;
        var pinchStart = null;
        var tapStart = null;
        var lastTapTime = 0;
        var lastTapPos = null;
        var TAP_MOVE_THRESHOLD = 6;
        var DOUBLE_TAP_MS = 300;

        function pointerDist() {
            var ids = Object.keys(pointers);
            if (ids.length < 2) return 0;
            var a = pointers[ids[0]], b = pointers[ids[1]];
            var dx = a.x - b.x, dy = a.y - b.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function pointerMid() {
            var ids = Object.keys(pointers);
            var a = pointers[ids[0]], b = pointers[ids[1]];
            return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        }

        function onPointerDown(e) {
            if (e.target !== img && e.target !== stage) return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
            pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
            var ids = Object.keys(pointers);
            if (ids.length === 1) {
                tapStart = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId };
                if (scale > 1.001) {
                    dragStart = { x: e.clientX, y: e.clientY, panX: panX, panY: panY };
                    lb.classList.add('is-grabbing');
                }
            } else if (ids.length === 2) {
                tapStart = null;
                dragStart = null;
                var d = pointerDist();
                var m = pointerMid();
                pinchStart = { dist: d, scale: scale, midX: m.x, midY: m.y, panX: panX, panY: panY };
            }
        }

        function onPointerMove(e) {
            if (!(e.pointerId in pointers)) return;
            pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
            var ids = Object.keys(pointers);
            if (tapStart && e.pointerId === tapStart.id) {
                var mdx = e.clientX - tapStart.x;
                var mdy = e.clientY - tapStart.y;
                if (Math.sqrt(mdx * mdx + mdy * mdy) > TAP_MOVE_THRESHOLD) tapStart = null;
            }
            if (ids.length === 2 && pinchStart) {
                e.preventDefault();
                var d = pointerDist();
                if (!d) return;
                var m = pointerMid();
                var newScale = Math.max(minScale, Math.min(maxScale, pinchStart.scale * (d / pinchStart.dist)));
                var stageRect = stage.getBoundingClientRect();
                var cx = stageW / 2, cy = stageH / 2;
                var sx0 = pinchStart.midX - stageRect.left;
                var sy0 = pinchStart.midY - stageRect.top;
                var ix = (sx0 - cx - pinchStart.panX) / pinchStart.scale;
                var iy = (sy0 - cy - pinchStart.panY) / pinchStart.scale;
                var sxN = m.x - stageRect.left;
                var syN = m.y - stageRect.top;
                scale = newScale;
                panX = sxN - cx - ix * scale;
                panY = syN - cy - iy * scale;
                clampPan();
                applyTransform();
            } else if (ids.length === 1 && dragStart) {
                var dx = e.clientX - dragStart.x;
                var dy = e.clientY - dragStart.y;
                panX = dragStart.panX + dx;
                panY = dragStart.panY + dy;
                clampPan();
                applyTransform();
            }
        }

        function onPointerUp(e) {
            var wasTap = false;
            var tapX = 0, tapY = 0;
            if (tapStart && e.pointerId === tapStart.id) {
                var mdx = e.clientX - tapStart.x;
                var mdy = e.clientY - tapStart.y;
                if (Math.sqrt(mdx * mdx + mdy * mdy) <= TAP_MOVE_THRESHOLD) {
                    wasTap = true;
                    tapX = e.clientX;
                    tapY = e.clientY;
                }
                tapStart = null;
            }
            delete pointers[e.pointerId];
            var ids = Object.keys(pointers);
            if (ids.length < 2) pinchStart = null;
            if (ids.length === 0) {
                dragStart = null;
                lb.classList.remove('is-grabbing');
            } else if (ids.length === 1 && scale > 1.001) {
                var only = pointers[ids[0]];
                dragStart = { x: only.x, y: only.y, panX: panX, panY: panY };
            }
            if (wasTap && ids.length === 0) {
                var now = Date.now();
                var isDouble = false;
                if (e.pointerType === 'touch' && lastTapPos) {
                    var ddx = tapX - lastTapPos.x;
                    var ddy = tapY - lastTapPos.y;
                    if (now - lastTapTime < DOUBLE_TAP_MS && Math.sqrt(ddx * ddx + ddy * ddy) < 30) isDouble = true;
                }
                if (e.pointerType === 'touch') {
                    if (isDouble) {
                        if (scale > 1.001) reset();
                        else zoomAt(tapX, tapY, 2.5);
                        lastTapTime = 0;
                        lastTapPos = null;
                    } else {
                        lastTapTime = now;
                        lastTapPos = { x: tapX, y: tapY };
                    }
                } else {
                    if (scale > 1.001) reset();
                    else zoomAt(tapX, tapY, 2.5);
                }
            }
        }

        function close() {
            lb.remove();
            document.removeEventListener('keydown', escHandler, true);
            window.removeEventListener('resize', onResize);
        }
        function escHandler(e) {
            if (e.key === 'Escape') { e.stopPropagation(); close(); }
            else if (e.key === '+' || e.key === '=') zoomCenter(scale * 1.25);
            else if (e.key === '-') zoomCenter(scale / 1.25);
            else if (e.key === '0') reset();
        }
        function onResize() { reset(); }

        lb.querySelector('.efx-sc-lb__close').addEventListener('click', close);
        lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
        btnIn.addEventListener('click', function () { zoomCenter(scale * 1.4); });
        btnOut.addEventListener('click', function () { zoomCenter(scale / 1.4); });
        btnReset.addEventListener('click', reset);

        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
        stage.addEventListener('wheel', onWheel, { passive: false });
        stage.addEventListener('pointerdown', onPointerDown);
        stage.addEventListener('pointermove', onPointerMove);
        stage.addEventListener('pointerup', onPointerUp);
        stage.addEventListener('pointercancel', onPointerUp);

        // Pencerenin Esc'inden önce yakalansın (sadece büyük görünüm kapansın)
        document.addEventListener('keydown', escHandler, true);
        window.addEventListener('resize', onResize);

        document.body.appendChild(lb);

        if (img.complete && img.naturalWidth) {
            measure();
            applyTransform();
        } else {
            img.addEventListener('load', function () { measure(); applyTransform(); }, { once: true });
        }
    }

    // ============================================================
    // Init
    // ============================================================
    async function init() {
        var pid = await getProductIdAsync();
        if (!pid) { dbgWarn('product id bulunamadı'); return; }
        dbg('product id:', pid);

        var resp = await sendToProxy({ action: 'getSizeChart', productId: pid });
        if (!resp || !resp.ok) { dbg('beklenmeyen yanıt'); return; }
        if (!resp.hasSizeChart || !resp.sizeChart || !resp.sizeChart.htmlContent) { dbg('size chart yok'); return; }

        SC.html = resp.sizeChart.htmlContent;
        injectStyles();
        placeLink();

        // Tema varyant alanını yeniden çizerse düğmeyi geri koy
        var moT = null;
        try {
            new MutationObserver(function () {
                if (moT) return;
                moT = setTimeout(function () { moT = null; placeLink(); }, 200);
            }).observe(document.body, { childList: true, subtree: true });
        } catch (e) {}

        // Pencereyi önceden hazırla (görseller açılmadan yüklensin)
        setTimeout(function () { try { buildModal(); } catch (e) {} }, 1200);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
